import { render, staticRenderFns } from "./productModal.vue?vue&type=template&id=338d3232&scoped=true&"
import script from "./productModal.vue?vue&type=script&lang=js&"
export * from "./productModal.vue?vue&type=script&lang=js&"
import style0 from "./productModal.vue?vue&type=style&index=0&id=338d3232&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338d3232",
  null
  
)

export default component.exports